import { useSelector } from 'react-redux';
import { SkeletonItemMobile, SkeletonList } from 'shared/components/SkeletonList';
import { selectOffers } from 'shared/selectors/offers';
import { getSkeletonItemsNodes } from '../../utils';
import { IOffer as IOfferMobile } from '../../../../../packages/OfferCardMobileWidget';

export const SkeletonListContainerMobile = () => {
  const offers = useSelector(selectOffers) as IOfferMobile[];

  const offersSkeletons = offers.map(({ isPromoted, media }) => ({
    isWide: isPromoted && media.length > 1,
  }));

  return <SkeletonList items={getSkeletonItemsNodes(offersSkeletons, SkeletonItemMobile)} />;
};
